import { useToggle } from 'ahooks';
import { useTradeAmountBlocks } from 'views/Conversation/Sider/useTradeAmountBlocks';
import type { TradeDetailAmountBlock } from 'views/Conversation/Sider/tradeDetailBlockTypes';
import { useTranslate } from '@tolgee/react';
import { ToggleButton } from 'components/LightConversation/components/ToggleButton';
import { PaymentAmountBlockContent } from './PaymentSectionBlocks';

export const PaymentSection = ({ order }: { order: Conversation.Trade.Vo }) => {
  const { t } = useTranslate();
  const [folded, { toggle }] = useToggle(true);
  const amountBlockMap = useTradeAmountBlocks(order as Conversation.Trade.TradeWithLogistics);
  const amountBlocks = [amountBlockMap.paymentAmount, amountBlockMap.incomeAmount].filter(
    (block): block is TradeDetailAmountBlock => Boolean(block),
  );

  if (amountBlocks.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center justify-end">
        <ToggleButton
          folded={folded}
          onToggle={toggle}
          foldText={t('展开详情')}
          unfoldText={t('隐藏详情')}
        />
      </div>
      <div className="flex flex-col gap-2">
        {amountBlocks.map((block) => (
          <PaymentAmountBlockContent
            key={block.id}
            block={block}
            order={order}
            showSmall={!folded}
          />
        ))}
      </div>
    </div>
  );
};
